module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.addNewCoupon()
      }
    }
  }, [_vm._v("新增贈送優惠券")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_set_list), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(coupon.coupon_info.name) + "\n        ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.changeCur(coupon, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-target": "#delCouponModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.curIndex = index
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)])]), _vm._v(" "), (_vm.curCoupon.coupon_info) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body form-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('h4', [_vm._v("編輯" + _vm._s(_vm.curCoupon.coupon_info.name))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.name),
      expression: "curCoupon.coupon_info.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "名稱",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.set_name),
      expression: "curCoupon.coupon_info.set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "名稱",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "set_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.description),
      expression: "curCoupon.coupon_info.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券說明",
      "maxlength": "1024"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.set_description),
      expression: "curCoupon.coupon_info.set_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券說明",
      "maxlength": "1024"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.set_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "set_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.remark),
      expression: "curCoupon.coupon_info.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券備註",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.coupon_info.discount_value),
      expression: "curCoupon.coupon_info.discount_value"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券折扣金額",
      "type": "text"
    },
    domProps: {
      "value": (_vm.curCoupon.coupon_info.discount_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.coupon_info, "discount_value", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.amount_unit),
      expression: "curCoupon.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "張數",
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.curCoupon.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.priceType,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.curCoupon.coupon_info.price_type),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.coupon_info, "price_type", $$v)
      },
      expression: "curCoupon.coupon_info.price_type"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType !== 10),
      expression: "getRoleType !== 10"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.couponType,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券類型",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.selectUSType,
      "input": _vm.changeUSType
    },
    model: {
      value: (_vm.curCoupon.usage_store_config.usage_store_type),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.usage_store_config, "usage_store_type", $$v)
      },
      expression: "curCoupon.usage_store_config.usage_store_type"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType !== 10),
      expression: "getRoleType !== 10"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.usageMethod,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.curCoupon.usage_store_config.usage_method),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.usage_store_config, "usage_method", $$v)
      },
      expression: "curCoupon.usage_store_config.usage_method"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCoupon.usage_store_config.usage_method.value !== 'order_store' && _vm.getRoleType !== 10),
      expression: "curCoupon.usage_store_config.usage_method.value !== 'order_store' && getRoleType !== 10"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.couponValue,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.selectUSValue
    },
    model: {
      value: (_vm.curCoupon.usage_store_config.usage_store_value),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.usage_store_config, "usage_store_value", $$v)
      },
      expression: "curCoupon.usage_store_config.usage_store_value"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.timeType,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.curCoupon.time_config.time_type),
      callback: function($$v) {
        _vm.$set(_vm.curCoupon.time_config, "time_type", $$v)
      },
      expression: "curCoupon.time_config.time_type"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'all_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.curCoupon.time_config.time.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'day_day' || _vm.curCoupon.time_config.time_type.value === 'day_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.time_config.use_start_day),
      expression: "curCoupon.time_config.use_start_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "天數",
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.curCoupon.time_config.use_start_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.time_config, "use_start_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'all_fixed' || _vm.curCoupon.time_config.time_type.value === 'day_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.curCoupon.time_config.time.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'day_day') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curCoupon.time_config.use_tolerance_day),
      expression: "curCoupon.time_config.use_tolerance_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "天數",
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.curCoupon.time_config.use_tolerance_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curCoupon.time_config, "use_tolerance_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCoupon.usage_store_config.usage_method.value === 'manual' && _vm.curCoupon.usage_store_config.usage_store_type.value !== 3 && _vm.getRoleType !== 10),
      expression: "curCoupon.usage_store_config.usage_method.value === 'manual' && curCoupon.usage_store_config.usage_store_type.value !== 3 && getRoleType !== 10"
    }],
    staticClass: "box-body form-center"
  }, [_vm._m(17), _vm._v(" "), _c('muti-select-two', {
    ref: "couponStoresMuti",
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('coupon-modal', {
    attrs: {
      "coupon": _vm.curCoupon
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券名稱(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券名稱(後台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券說明(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券說明(後台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券備註(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券折扣金額")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("一次發送張數")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券稅制")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("適用門市方式")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("適用對象")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("有效期間設定")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始時間")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("拿到優惠券後幾天開始")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束時間")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始後幾天結束")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券可用店家")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20e41f39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/CouponList.vue
// module id = 2351
// module chunks = 1